// @ts-nocheck

export const localeCodes =  [
  "ru",
  "ky"
]
export const localeLoaders = {
  ru: [
    {
      key: "locale_ru_46json_c16480c2",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ky: [
    {
      key: "locale_ky_46json_d8fac039",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/c82d5d30" /* webpackChunkName: "config_i18n_46config_46ts_c82d5d30" */)
]
export const normalizedLocales = [
  {
    code: "ru",
    iso: "ru-RU",
    name: "Русский",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ky",
    iso: "ky-KG",
    name: "Кыргызча",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

